import { format, isSaturday } from 'date-fns';

import { TimeFilter } from '@/models/Filter';

export const DAY_KEY_FORMAT = 'yyyy-MM-dd';
export const AFTERNOON_START_HOUR = 12;

export const MORNING_TIME_BEFORE: TimeFilter = '11:59:59';
export const AFTERNOON_TIME_AFTER: TimeFilter = '12:00:00';

export type DayPeriod = 'AM' | 'PM';

export const isSplitDay = isSaturday;

export const toDayKey = (date: Date) => format(date, DAY_KEY_FORMAT);

export const getDayPeriod = (date: Date): DayPeriod =>
  date.getHours() < AFTERNOON_START_HOUR ? 'AM' : 'PM';

export const toColumnKey = (date: Date) =>
  isSplitDay(date) ? `${toDayKey(date)}:${getDayPeriod(date)}` : toDayKey(date);
